import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroSection() {
  return <section data-section-id="257465" id="hero-section" className="relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/residential_roofing_work.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/residential_roofing_work.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/residential_roofing_work.png-wvc-sizes" alt="Professional roofing work by Eagle Exteriors" className="w-full h-full object-cover object-center" loading="eager" />
        <div className="absolute inset-0 bg-primary-900/70" aria-hidden="true"></div>
      </div>

      {}
      <div className="relative z-10 page-container flex flex-col items-center text-center text-white py-20 md:py-32">
        <h1 className="font-default text-5xl md:text-[72px] leading-tight font-bold mb-6 max-w-5xl drop-shadow-lg">
          Proudly Serving Homeowners Across Maryland & Northern Virginia
        </h1>
        
        <p className="font-default text-lg md:text-xl mb-10 max-w-2xl text-primary-100 drop-shadow-md">
          Eagle Exteriors provides professional roofing, siding, gutter, and storm damage services throughout Maryland and surrounding communities.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
          <Button asChild className="w-full sm:w-auto bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-md h-14 px-8 text-lg font-bold shadow-xl transition-all">
  <Link to="/ContactPage">
    Get a Free Estimate
  </Link>
</Button>

<Button asChild variant="outline" className="w-full sm:w-auto h-14 px-8 text-lg font-bold border-secondary text-secondary hover:bg-secondary/10 hover:text-secondary rounded-md transition-all">
  <Link to="tel:2408991278">
    Call Now
  </Link>
</Button>
        </div>
      </div>
    </section>;
}